export default __webpack_public_path__ + "static/media/BadgerHacksArticle.b1a75783.png";